import { useCallback, useContext } from 'react';
import { SnackbarContext } from './Snackbar';
import type { ShowSnackbar, SnackbarOptions } from './types';

/**
 * @deprecated Используйте глобальные `showSnackbar` / `hideSnackbar` из `@web-chat-core/ui-kit`.
 * Они работают в глобальном контексте.
 */
export const useSnackbar = () => {
    const { show, hide } = useContext(SnackbarContext);

    const showSnackbar = useCallback<ShowSnackbar>(
        (label: string, options: SnackbarOptions = {}) => {
            show(typeof label === 'string' ? label : String(label), options);
        },
        [show],
    );

    return {
        showSnackbar,
        hideSnackbar: hide,
    };
};
